import React from 'react';
import BubbleCommon, {
  newsEngagementTips,
  newsUVPMTips,
} from '@op/components/BubbleCommon';
import moment from 'moment';
import { keywordRenderFunc } from '@op/utils/text';
import ArticleReviews from './components/ArticleReviews';
import TopicBox from '@op/components/TopicBox';

import { reviewsFormat } from '@op/utils/value';
import { newsDataSourceIconMap } from '@op/constants/news';
import TranslateSelect from '@op/components/SelectComponents/TranslateSelect';
import { languageSelectOptions } from '@op/components/FilterBoxCommon/constant';
export type keys = 'video' | 'view' | 'follower' | 'engagement';

export const newsMediaColumnsFunc = ({
  formatMessage,
  language,
  renderKey,
  topicList,
  logCommentMap,
  logLoading,
  MergeChannelIconElement,
  setLanguage,
  formatOptionsMessage,
}: any) => {
  function getContentInfo(content: string, renderKey: string | Array<string>) {
    return keywordRenderFunc({
      text: content,
      keyword: renderKey,
      titleCase: true,
    });
  }

  function getUpdateFilter(cvm: any) {
    return {
      unified_id: cvm.unified_id,
      edition_id: cvm.edition_id,
      comment_time: moment(cvm.comment_time).format('YYYY-MM-DD HH:mm:ss'),
      comment_uin: cvm.comment_uin,
      comment_create_time: moment(cvm.create_time).format(
        'YYYY-MM-DD HH:mm:ss',
      ),
    };
  }

  return {
    article: {
      key: 'post',
      header: (
        <div className="dbo-table-header-article">
          {formatMessage({ id: 'Article' })}
          <TranslateSelect
            langOptions={formatOptionsMessage(languageSelectOptions)}
            lang={language}
            isSingle={true}
            getChange={(e: any) => {
              setLanguage(e);
            }}
            defaultValueText={formatMessage({ id: 'Language' })}
            originalText={'Original Language'}
          />
        </div>
      ),
      width: 520,
      fixed: 'left',
      render: (cvm: any) => {
        return (
          <ArticleReviews
            logCommentMap={logCommentMap}
            logLoading={logLoading}
            data={cvm}
            language={language}
            getContentInfo={(text: string) => getContentInfo(text, renderKey)}
          ></ArticleReviews>
        );
      },
    },
    uvpm: {
      key: 'uvpm',
      header: (
        <div className="dbo-tablecommon-header">
          <span> {formatMessage({ id: 'Reach' })} </span>
          <BubbleCommon tipsMap={newsUVPMTips}></BubbleCommon>
        </div>
      ),
      width: 130,
      render: (cvm: any) => {
        return reviewsFormat(cvm.visit_number || 0);
      },
    },
    engagement: {
      key: 'engagement',
      header: (
        <div className="dbo-tablecommon-header">
          <span> {formatMessage({ id: 'Engagement' })} </span>
          <BubbleCommon
            tipsMap={newsEngagementTips}
            extraContent={
              MergeChannelIconElement && (
                <MergeChannelIconElement
                  metric={'engagement'}
                ></MergeChannelIconElement>
              )
            }
          ></BubbleCommon>
        </div>
      ),
      width: 190,
      render: (cvm: any) => {
        return reviewsFormat(cvm.engagement || 0);
      },
    },
    release_time: {
      key: 'release_time',
      header: formatMessage({ id: 'Published Time' }),
      width: 190,
      render: (records: any) => {
        const textTime = moment(records.release_time).format(
          'YYYY-MM-DD HH:mm',
        );
        return textTime;
      },
    },
    data_source: {
      key: 'data_source',
      header: formatMessage({ id: 'Data Source' }),
      width: 160,
      render: (cvm: any) => {
        const dataSource: 'DataBrain' = cvm.data_source;
        const icon = newsDataSourceIconMap[dataSource];
        return (
          <div className="dbo-inlineflex">
            {icon && (
              <img src={icon} style={{ height: 14, marginRight: '4px' }} />
            )}
            {dataSource}
          </div>
        );
      },
    },
    type_of_coverage: {
      key: 'coverage_type',
      header: formatMessage({ id: 'Type of Coverage' }),
      width: 190,
    },
    beat: {
      key: 'beat',
      header: formatMessage({ id: 'Beat' }),
      width: 190,
    },
    topic: {
      key: 'topic',
      header: formatMessage({ id: 'Topic' }),
      align: 'left',
      width: 225,
      render: (cvm: any) => {
        return (
          <TopicBox
            topicList={topicList}
            noEdit
            needRequest={false}
            data={cvm}
          />
        );
      },
    },
  };
};
